var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from "react";
import classNames from "classnames";
// styles
import "./slider.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-slider",
    disabled: false,
};
const Slider = (_a) => {
    var { value, onMouseDown, onMouseUp, disabled, className, label, helpText, error } = _a, rest = __rest(_a, ["value", "onMouseDown", "onMouseUp", "disabled", "className", "label", "helpText", "error"]);
    const classList = classNames("tecma-slider", { disabled }, className);
    const sliderRef = useRef(null);
    // 8 to avoid the pointer go outside the progress bar. 8 is half of the pointer diameter
    const [nextPointerPosition, setNextPointerPosition] = useState(value === 0 ? 8 : value);
    /**
     *  isProgressBarClicked boolean value indicates if the progress bar has been clicked or not
     */
    const isProgressBarClicked = useRef(false);
    const handleOnMouseMove = (e) => {
        if (sliderRef.current) {
            const { width, left } = sliderRef.current.getBoundingClientRect();
            const movement = e.pageX - left + 8;
            if (isProgressBarClicked.current === true && movement <= width + 8 && movement > 8) {
                setNextPointerPosition(movement);
                if (onMouseDown) {
                    onMouseDown();
                }
            }
        }
    };
    const handleOnMouseDown = (e) => {
        isProgressBarClicked.current = true;
        handleOnMouseMove(e);
    };
    const handleOnMouseUp = () => {
        if (isProgressBarClicked.current) {
            isProgressBarClicked.current = false;
            if (onMouseUp) {
                onMouseUp();
            }
        }
    };
    return (_jsxs("div", { className: "tecma-slider-container", children: [label && _jsx("span", { className: "slider-label", children: label }), _jsx("div", Object.assign({ className: classList, onMouseDown: handleOnMouseDown, onMouseMove: handleOnMouseMove, onMouseUp: handleOnMouseUp, onMouseLeave: handleOnMouseUp, ref: sliderRef, role: "presentation" }, rest, { children: _jsx("div", { className: "slider-container", style: { width: `${nextPointerPosition}px` }, children: _jsx("div", { className: "slider-pointer" }) }) })), helpText && (_jsx("span", { className: error ? "slider-helpText slider-helpText-errored" : "slider-helpText", children: helpText }))] }));
};
Slider.defaultProps = defaultProps;
/**
 * A form control for choosing a value within a preset range of values.
 */
export default React.memo(Slider);
